import regionService, { DEFAULT_REGION } from "@irati/region/services/region";
import { PRODUCTION, E2E, SANDBOX } from "../constants/environment";
import env from "../env";
export default function getUrlForEnv(service, path) {
    var override = env.API_GW;
    if (override && isPerkboxUrl(override)) {
        return "" + override + service + path;
    }
    var region = regionService.get() || DEFAULT_REGION;
    var environment = env.ENVIRONMENT_NAME;
    if (environment === PRODUCTION) {
        return "https://api.production." + region + ".perkbox.services/" + service + path;
    }
    else if (environment === E2E) {
        return "https://api.e2e." + region + ".perkbox.services/" + service + path;
    }
    else if (environment === SANDBOX) {
        return "https://api.sandbox." + region + ".perkbox.services/" + service + path;
    }
    return "https://api.staging." + region + ".perkbox.services/" + service + path;
}
export var services = {
    BILLING_GATEWAY_SERVICE: "billing-gateway",
    BILLING_PRICEBOOK_SERVICE: "billing-pricebook",
    BILLING_SERVICE: "billing",
    CHANNEL_PARTNER_SERVICE: "channel-partner",
    FILE_SERVICE: "file",
    GRAPH_QL_SERVICE: "graphql",
    IDENTITY_SERVICE: "identity",
    INSIGHTS_QUESTION_SERVICE: "insights-question",
    INSIGHTS_SURVEYS_SERVICE: "surveys",
    LOGIN_SERVICE: "login",
    MEDICAL_SERVICE: "medical",
    METADATA_SERVICE: "metadata",
    ONBOARDING_SERVICE: "onboarding",
    OPEN_API_SERVICE: "open-api",
    PAYMENTS_V2_SERVICE: "payments-v2",
    PERMISSIONS_SERVICE: "permissions",
    SSO_SERVICE: "sso",
    REPORTING_SERVICE: "reporting"
};
function isPerkboxUrl(url) {
    var _a;
    // Must start with "https" + must end with "perkbox.services"
    // All other characters must be a-z or - to stop other domain injection.
    var regex = /^https:\/\/[a-z0-9-.]*\.perkbox\.services\/$/i;
    return ((_a = url.match(regex)) === null || _a === void 0 ? void 0 : _a.length) === 1;
}
